module.exports = __webpack_public_path__ + "static/img/defaultPhoto0.035a905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultPhoto0.jpg
// module id = A5HC
// module chunks = 2